import cx from 'classnames';

import Button from 'components/shared/Button';
import Divider from 'components/shared/Divider';
import Text from 'components/shared/Typography/Text';

import s from '../index.module.css';
import { IToolTipStepProps, IToolTipSwitchProps } from '../types';

export const ToolTipStep = ({
  id,
  title,
  bodyText,
  buttonText,
  activeStep,
  stepsCount,
  onDotClick,
  onClick,
}: IToolTipStepProps) => {
  const dots = Array.from({ length: stepsCount }, (_, idx) => {
    const stepNumber = idx + 1;
    return (
      <span
        className={cx(s.dot, { [s.dot_active]: activeStep === stepNumber })}
        onClick={() => onDotClick(stepNumber)}
      />
    );
  });

  return (
    <div className={cx(s.step, { [s.disabled]: id !== activeStep })}>
      <Text accent isStrong className={s.title}>
        {title}
      </Text>
      <Divider noMargin />
      <Text accent className={s.bodyText}>
        {bodyText}
      </Text>
      <div className={s.footer}>
        <div className={s.dots}>{dots}</div>
        <div>
          <Button type="grey" onClick={onClick} className={s.stepButton}>
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export const ToolTipSwitch = ({ children }: IToolTipSwitchProps) => {
  return <div className={s.wrapper}>{children}</div>;
};
